import { z } from "zod";

export const CarrierContactPrefillCandidateSchema = z.object({
  contactId: z.string().uuid(),
  label: z.string(),
  formattedValue: z.string(),
});

export type CarrierContactPrefillCandidate = z.infer<typeof CarrierContactPrefillCandidateSchema>;

export const CarrierContactPrefillSchema = z.object({
  supplierId: z.string().uuid().nullable(),
  supplierName: z.string().nullable(),
  prefillValue: z.string(),
  candidates: z.array(CarrierContactPrefillCandidateSchema),
});

export type CarrierContactPrefill = z.infer<typeof CarrierContactPrefillSchema>;

export const emptyCarrierContactPrefill = (): CarrierContactPrefill => ({
  supplierId: null,
  supplierName: null,
  prefillValue: "",
  candidates: [],
});
